import whatsAppImg from '@/images/whatsApp.png';
import { trackEvent, trackType } from '@/utils/trackUtils';
import { omit } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';
import { useNonPassiveEventListener } from '../../../hooks';
import useSafeBarHeight from '../../../hooks/useStatusBarHeight';
import { nativeApi } from '../../../utils/nativeApi';
import { whatsAppConfig } from '../interface';
import style from './index.module.less';

function WhatsApp(props: { prop: whatsAppConfig | boolean | undefined }) {
  const { prop } = props;

  const [point, setPoint] = useState<{ x: number; y: number }>();
  const imgRef = useRef<HTMLImageElement>();
  const [halfIconSize, setHalfIconSize] = useState(0);
  const [moving, setMoving] = useState(false);

  const [safeBorder, setSafeBorder] = useState({
    top: 0,
    left: 0,
    right: window.innerWidth,
    bottom: window.innerHeight,
  });

  const [safeBarHeight] = useSafeBarHeight();
  const [safeBottomHeight] = useSafeBarHeight();

  useEffect(() => {
    setSafeBorder(
      Object.assign(safeBorder, {
        top: safeBarHeight,
        bottom: window.innerHeight - safeBottomHeight,
      })
    );
  }, [safeBarHeight, safeBottomHeight]);

  const onTouchMove = (event: TouchEvent) => {
    setMoving(true);
    setPoint({
      x: event.touches[0].pageX - halfIconSize,
      y: event.touches[0].pageY - halfIconSize,
    });
    event.preventDefault();
    event.stopPropagation();
  };

  const onTouchEnd = () => {
    if (!moving) {
      return;
    }
    setTimeout(() => {
      setMoving(false);
    }, 300);
    let newX = point?.x || 0;
    let newY = point?.y || 0;
    if (newX < safeBorder.left) {
      newX = safeBorder.left;
    }
    if (newX > safeBorder.right) {
      newX = safeBorder.right;
    }
    if (newY < safeBorder.top) {
      newY = safeBorder.top;
    }
    if (newY > safeBorder.bottom) {
      newY = safeBorder.bottom;
    }

    const winHalfWidth = window.innerWidth / 2;
    if (newX + halfIconSize > winHalfWidth) {
      newX = safeBorder.right;
    } else {
      newX = safeBorder.left;
    }

    setPoint({
      x: newX || 0,
      y: newY || 0,
    });
  };

  useEffect(() => {
    if (imgRef.current) {
      const computedStyle = window.getComputedStyle(imgRef.current);
      const iconHeight = Number.parseFloat(computedStyle.width);
      setHalfIconSize(iconHeight / 2);
      setSafeBorder(
        Object.assign(safeBorder, {
          right: window.innerWidth - iconHeight,
          bottom: window.innerHeight - iconHeight,
        })
      );
    }
  }, []);

  // 使用自定义 Hook 替换原来的事件监听器代码
  useNonPassiveEventListener(imgRef, [
    {
      type: 'touchmove',
      handler: onTouchMove as EventListener,
    },
    {
      type: 'touchend',
      handler: onTouchEnd,
    },
  ]);

  const onHref = () => {
    if (!moving) {
      trackEvent([trackType.SENSORS], 'click_WhatsApp');
      nativeApi.gotoWhatsApp?.();
    }
  };

  return (
    // 解决小范围移动依旧触发点击事件的问题
    <div onClick={onHref}>
      <img
        ref={imgRef}
        alt=""
        src={whatsAppImg}
        style={{ top: point?.y, left: point?.x }}
        className={`${style.whatsapp} ${prop !== true ? prop : ''}`}
        {...omit(prop, 'className')}
      />
    </div>
  );
}

export default WhatsApp;
